// Third party
import * as yup from 'yup';

yup.setLocale({
  mixed: {
    required: '',
  },
});

const CreateUpdatePackagesSchema = yup.object({
  name: yup.string().required(''),
  assigned_accounts: yup
    .array()
    .of(yup.string().required())
    .default([]),
  assigned_items: yup
    .array()
    .of(yup.string().required())
    .min(1, '')
    .required(),
  file_content: yup.array().default([]),
});

export { CreateUpdatePackagesSchema };